/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

import React from 'react';

import FormElementLabel from './FormElementLabel';
import FormElementHelper from './FormElementHelper';
import ValidationMessage from './ValidationMessage';
import * as types from '../types';

export type FormElementWrapperProps = types.IFormElement & {
    required?: boolean
    children: any
};

const FormElementWrapper = ({ id, name, label, error, helper, required, children, labelClassName, noRenderStar }: FormElementWrapperProps) => (
    <>
        {
            label &&
            <FormElementLabel
                className={labelClassName}
                noRenderStar={noRenderStar}
                htmlFor={id || name}
                required={required}>
                {label}
            </FormElementLabel>
        }
        {
            helper &&
            <FormElementHelper>{helper}</FormElementHelper>
        }
        {children}
        {
            error &&
            <ValidationMessage>{error}</ValidationMessage>
        }
    </>
);

export default FormElementWrapper;
